/**
 * @voltxampere/ui — Tunnel diode (Sprint 45-4, placeholder)
 *
 * PLACEHOLDER. Negative differential resistance (NDR) bölgesi —
 * gerçek I-V curve (peak + valley + N-shape) Sprint 50+ engine
 * extension #4 ile (custom non-monotonic stamp). Şu anki stamp
 * standart Shockley diode davranışı.
 *
 * Reference: Generic tunnel diode — Esaki 1958 invention. Highly
 * doped p-n junction, V_peak ~50 mV (Ge) / ~100 mV (Si), I_peak/
 * I_valley ratio 5-10. Mikrowave oscillator (1-100 GHz), high-speed
 * switching (sub-ns), amplifier (low-noise). Quantum tunneling
 * fenomenini görselleştirir.
 *
 *   Default mapping → diode schemaType:
 *     saturationCurrent = 1e-14
 *     ideality = 1
 *
 * Engine zero-diff invariant honored — canonical `diode` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { diode } from "../diode.js";
export const diodeTunnel = {
    id: "tunnel-diode",
    nameTr: "Tunnel Diode (Esaki, NDR, placeholder)",
    nameEn: "Tunnel Diode (Esaki, NDR, placeholder)",
    shortcut: "D",
    category: "active",
    viewBox: diode.viewBox,
    terminals: diode.terminals,
    defaultLabel: "D",
    defaultValue: "TUNNEL",
    schemaType: "diode",
    defaultParams: { saturationCurrent: 1e-14, ideality: 1 },
    renderSVG: () => diode.renderSVG(),
};
//# sourceMappingURL=diode-tunnel.js.map